import '../components/Tab.css';
import Box from '../components/Box';
import Icon from '../components/Icon';
import Text from '../components/Text';
import { translate } from '../locale';
import React, { useState } from 'react';
import { useBooking } from '../BookingProvider';
import courseService from '../services/courseService';
import { useHistory, useParams } from '../hooks/useParams';
import BookingFormModal from '../components/BookingFormModal';
import BookingListViewItem from '../components/BookingListViewItem';

export default function BookingPage() {
  const { type: urlType } = useParams();
  const booking = useBooking();
  const history = useHistory();
  const [succeeded, setSucceeded] = useState(false);

  const type = courseService.mapUrlTypeToType(urlType);

  return (
    <Box paddingHorizontal={16}>
      <Box marginTop={16} cursor='pointer' onClick={() => history.push(`/${urlType}`)}>
        <Icon icon='arrow-left' size={24} />
      </Box>
      {
        succeeded &&
        <Text><div dangerouslySetInnerHTML={{ __html: translate('de', 'successMessage', 'VKUPart1') }}></div></Text>
      }
      {
        succeeded &&
        type !== "MotorcycleTraining" &&
        <Text><div dangerouslySetInnerHTML={{ __html: translate('de', 'successMessage', 'ReservationUntil') }}></div></Text>
      }
      {
        succeeded &&
        <Text><div dangerouslySetInnerHTML={{ __html: translate('de', 'successMessage', 'VKUPart2') }}></div></Text>
      }
      {
        booking.courses.map((item) =>
          <BookingListViewItem
            key={item._id}
            course={item}
          />
        )
      }
      {
        !succeeded &&
        <BookingFormModal type={urlType} courses={booking.courses} onSucceeded={() => setSucceeded(true)} />
      }
    </Box>
  );
}